/**
 * Ancienne route « nouvelle descente » — redirection métier vers Passage exceptionnel.
 * Le formulaire historique reste dans NouvelleDescente.tsx mais n’est plus monté par le routeur.
 */
import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";

export default function NouvelleDescenteLegacyRedirect(): React.JSX.Element {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6 text-slate-100">
      <div className="max-w-lg rounded-2xl border border-amber-500/30 bg-amber-500/5 p-8 shadow-xl">
        <AlertTriangle className="h-12 w-12 text-amber-400" aria-hidden />
        <h1 className="mt-4 text-xl font-bold text-white">Ce flux est remplacé par Passage exceptionnel</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-400">
          La création manuelle de descente n’est plus disponible. Utilisez une demande d’urgence contrôlée, puis
          affectation Passage / Tournée selon les règles métier.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
          <Link
            to="/admin/passages/urgence"
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl bg-emerald-600 px-5 py-3 text-sm font-semibold text-white hover:bg-emerald-500"
          >
            Passage exceptionnel
            <ChevronRight className="h-4 w-4" />
          </Link>
          <Link
            to="/admin/planificateur"
            className="inline-flex flex-1 items-center justify-center gap-2 rounded-xl border border-slate-600 px-5 py-3 text-sm font-medium text-white hover:bg-slate-800"
          >
            Planning des passages
          </Link>
        </div>
      </div>
    </div>
  );
}
